import React from 'react';

interface ISkeletonProps {
    isLoading?: boolean;
}

const skeleton: React.FC<ISkeletonProps> = ({ isLoading = true }): JSX.Element => {
    return <span className={`msc-skeleton${isLoading ? '--animated' : ''}`}>&zwnj;</span>;
};

export default skeleton;
